/**
 * /cleo — full-page Cleo experience.
 */
import React from 'react';
import { useTheme } from '../lib/theme';
import CleoChat from '../components/CleoChat';

export default function CleoPage() {
  const { colors } = useTheme();
  return (
    <div className="flex flex-col h-full" style={{ backgroundColor: colors.bg }}>
      {/* Hero */}
      <div className="flex items-center gap-4 px-6 py-6 border-b"
        style={{ borderColor: colors.border, backgroundColor: colors.surface }}>
        <img src="/cleo-avatar.png" alt="Cleo"
          className="w-14 h-14 rounded-full"
          style={{ boxShadow: `0 0 24px ${colors.accent}77` }} />
        <div>
          <h1 className="text-2xl font-bold tracking-tight" style={{ color: colors.text }}>Cleo</h1>
          <p className="text-sm" style={{ color: colors.textMuted }}>
            Your Clasifi assistant — ask about your score, spending, taxes, or anything else.
          </p>
        </div>
      </div>

      {/* Chat body */}
      <div className="flex-1 min-h-0 max-w-3xl w-full mx-auto">
        <CleoChat />
      </div>
    </div>
  );
}
